import cx from 'classnames'

import { useGameSlug } from '../../game-provider'

import storefronts from '../storefronts.module.scss'

export const StoreContent = ({ children }: { children: React.ReactNode }) => {
  const gameSlug = useGameSlug()
  return (
    <div
      className={cx(storefronts.storeContent, storefronts[gameSlug])}
      style={{ ...(gameSlug === 'clashroyale' && { backgroundImage: `url('/images/clashroyale/offers-bg.png')` }) }}
    >
      {children}
    </div>
  )
}
